<template>
    <div>
        <el-select class="w-100"
                   placeholder="Select Ticket or Start Typing to Search"
                   v-model="selectedTicket"
                   @change="selectTicket"
                   @focus="fetchTickets()"
                   :remote-method="fetchTickets"
                   filterable
                   remote
                   :loading="loading">
            <el-option
                    class="ticket-dropdown-item"
                    v-for="ticket in tickets"
                    :key="ticket.id"
                    :label="ticket.ticket_reference_number"
                    :value="ticket.id">
                <div>
                    <div style="max-width: 400px">
                        <div v-if="showAssetName">
                            {{ticket.asset_name}}
                        </div>
                        <div>
                            <i class="mdi mdi-tag-text-outline font-16" :class="'priority-' + (ticket.priority ? ticket.priority.toLowerCase() : 'low')"></i>
                            <span>{{ ticket.ticket_reference_number }}
                                <i class="mdi mdi-calendar icon-light"></i>
                                {{ ticket.logged_at | datetime }}
                                <span class="label label-light-info pull-right">{{ ticket.status }}</span>
                            </span>
                        </div>
                        <div>
                            <p class="mb-0 mt-1 font-sm">{{ ticket.description }}</p>
                        </div>
                    </div>
                </div>
            </el-option>
        </el-select>
    </div>
</template>

<script>
  export default {

    props: ["api", "showAssetName"],

    data() {
      return {
        tickets: [],
        selectedTicket: null,
        search: "",
        loading: false
      };
    },

    methods: {

      fetchTickets(query) {

        this.search = query;
        this.loading = true;
        axios.get(this.api, { params: { filter: query } })
          .then(response => {
            this.tickets = response.data;
            this.loading = false;
          });

      },

      selectTicket(ticketId) {
        this.$emit("input", ticketId);
      }

    }

  };
</script>

<style scoped>

    .ticket-dropdown-item {
        white-space: normal !important;
        overflow: auto !important;
        height: auto !important;
        line-height: 22px !important;
        padding: 8px 20px !important;
    }

</style>